import ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';
import { getCookie, setCookie } from '../utils/cookies';
import {
  passwordLockCookie,
  passwordLockFormUrl,
  passwordLockSessionId,
  isPasswordProtectionEnabledInEnv,
} from 'src/scripts/passwordLock';
import FormInput from 'src/scripts/templates/_shared/ui-components/YogaUI/FormInput';
import '../../styles/templates/pages/page.store-password-protect.scss';
import { prependLocaleToPath } from '../utils/localization';

const PasswordLockForm = () => {
  const [password, setPassword] = useState('');
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    var myCookieValue = getCookie(passwordLockCookie);
    if (myCookieValue === passwordLockSessionId || !isPasswordProtectionEnabledInEnv(window.Shopify.shop)) {
      window.location.href = prependLocaleToPath('/');
    }
    if (window.isSessionValid) {
      setCookie(passwordLockCookie, passwordLockSessionId, 7);
      window.location.href = prependLocaleToPath('/');
    } else {
      const URLparams = new URLSearchParams(window.location.search);
      setErrorState(Boolean(URLparams.get('uuid')));
    }
  }, []);

  return (
    <div className="lock-form-wrapper">
      <form
        key="password_lock"
        onSubmit={(event) => {
          event.preventDefault();
          window.location.href = prependLocaleToPath(passwordLockFormUrl + '?uuid=' + btoa(password));
        }}
      >
        <h1>Enter the password to access the site</h1>
        <div className="form-group">
          <FormInput
            options={{
              id: 'password',
              wrapperClasses: '',
              type: 'password',
              required: true,
              errorText: 'Please enter the password',
              label: 'Password',
              onChange: (event) => {
                setPassword(event.currentTarget.value);
              },
            }}
          />
          {errorState ? <span className="error">You have entered an invalid password</span> : null}
        </div>
        <div className="form-group">
          <input
            type="submit"
            className="btn btn-primary btn-block"
            value="Submit"
            onClick={() => setErrorState(false)}
          />
        </div>
      </form>
    </div>
  );
};

const targetElement = document.querySelector('[react-render-target="password-lock-form"]');
ReactDOM.render(<PasswordLockForm />, targetElement);
